import { useField, useFormikContext } from 'formik';
import { pipe } from 'fp-ts/lib/function';
import { fromNullable, getOrElse } from 'fp-ts/lib/Option';
import { useMemo } from 'react';

export type FieldMessageType = 'error';

const findServerError = (status: any, name: string) => {
  const serverErrors = status && status[name];

  return serverErrors && serverErrors.length > 0
    ? pipe(
        serverErrors[0],
        fromNullable,
        getOrElse(() => 'No error message provided 😳')
      )
    : undefined;
};

/** Provides a wrapper around Formiks internal `useField`.
 * This allows us to pull and display server side errors from the status object
 * contained within `FormikContext`. */
export const useFormikField = (props: any) => {
  const [fieldProps, meta, helpers] = useField(props);
  const form = useFormikContext();

  return useMemo(() => {
    const error = meta.error && meta.touched ? meta.error : undefined;
    const serverError = findServerError(form.status, props.name);

    return [fieldProps, serverError || error, helpers] as const;
  }, [fieldProps, meta, form.status, helpers, props.name]);
};

export const useFormikServerError = () => {
  const form = useFormikContext();

  return useMemo(() => {
    const error = form.status && form.status.__server_error;

    return error;
  }, [form.status]);
};
